import {countries, currencies, continents} from 'country-data';
import i18nCountries from 'i18n-iso-countries';

/* eslint-disable */
i18nCountries.registerLocale(require("i18n-iso-countries/langs/zh.json"));
i18nCountries.registerLocale(require("i18n-iso-countries/langs/en.json"));

export const getCountryObj = (language: string) => {
  const countryObj = i18nCountries.getNames(language);
  const countryListObj = {};
  let countryData;
  let country;
  let currency;
  for (const alpha2 in countryObj) {
    if (Object.prototype.hasOwnProperty.call(countryObj, alpha2)) {
      countryData = {
        name: countryObj[alpha2],
        alpha2,
      };
      // 查询当前国家所在的洲信息
      for (let key in continents) {
        if (continents[key].countries.indexOf(alpha2) !== -1) {
          countryData.continent = key;
        }
      }
      country = countries[alpha2];
      if (country && country.currencies.length > 0) {
        currency = currencies[country.currencies[0]];
        countryData.emoji = country.emoji;
        countryData.currencyName = currency.name;
        countryData.symbol = currency.symbol;
        countryListObj[alpha2] = countryData;
      }
    }
  }
  return countryListObj;
};
